<template>
    <div class="main-calendar">
        <div class="header-calendar">
            <a class="logo"><img src="@/assets/images/boating.png" alt=""></a>
            <div class="rental-ability">
                <p class="text-select">Rental Availability for</p>
                <div class="calendar-select">
                    <img @click="clickPreviousMonth" class="button-select" src="@/assets/images/left.png"/>
                    <p class="text-select fixed-width">{{currentMonthText}} {{currentYear}}</p>
                    <img @click="clickNextMonth" class="button-select" src="@/assets/images/right.png"/>
                </div>
            </div>
        </div>
        <div class="card-list">
            <div class="list-day">
                <div class="scape-day"></div>
                <div class="day-weeks add-custom-left">
                    Mo<span>nday</span>
                </div>
                <div class="scape-day"></div>
                <div class="day-weeks">
                    Tu<span>esday</span>
                </div>
                <div class="scape-day"></div>
                <div class="day-weeks">
                    We<span>dnesday</span>
                </div>
                <div class="scape-day"></div>
                <div class="day-weeks">
                    Th<span>ursday</span>
                </div>
                <div class="scape-day"></div>
                <div class="day-weeks">
                    Fr<span>iday</span>
                </div>
                <div class="scape-day"></div>
                <div class="day-weeks">
                    Sa<span>turday</span>
                </div>
                <div class="scape-day"></div>
                <div class="day-weeks add-custom-right">
                    Su<span>nday</span>
                </div>
            </div>
            <div class="cards">
                <div 
                    v-for="(day,index) in listDaysInMonth" :key="index" 
                    @click="showInfoAvaibility(day.availability)" class="card" 
                    :class="{'none-visible': !day.is_visible, 'd-none': day.displayNone}">
                    <div class="card-top">
                        {{day.date}}
                    </div>

                    <div class="card-bottom" :style="`background-image: linear-gradient(#fff, ${day.color} 20%);`">
                        <span>{{windowWidth > 600 ? day.label : day.label.split('')[0]}}</span>
                    </div>
                </div>

            </div>
        </div>
        <ShowDayModal ref="ShowDayModal"></ShowDayModal>
    </div>
</template>

<script>
import ShowDayModal from './ShowDayModal.vue'
import {listMonth} from './utils'
import DibbleJS from '../../dibble'
import DibbleApi from '../../api'
export default {
    name: "Calendar",
    data() {
        return {
            dibbleJs: DibbleJS,
            listMonth,
            currentMonth: 0,
            currentYear: 0,
            currentMonthText: '',
            listDaysInMonth: [],
            selectedAvailability: [],
            windowWidth: window.innerWidth
        }
    },
    components: {
        ShowDayModal
    },
    methods: {
        showInfoAvaibility (selectedAvailability) {
            this.$refs.ShowDayModal.showModal(selectedAvailability);
        },
        clickPreviousMonth () {
            const monthFindIndex = this.listMonth.findIndex(el => el.key === this.currentMonth)
            if (monthFindIndex) {
                this.currentMonth = this.listMonth[monthFindIndex - 1].key
            } else {
                this.currentMonth = 12
                this.currentYear--
            }
            this.getListRentalBoatAcordingMonth()
        },
        clickNextMonth () {
            const monthFindIndex = this.listMonth.findIndex(el => el.key === this.currentMonth)
            if (monthFindIndex < 11) {
                this.currentMonth = this.listMonth[monthFindIndex + 1].key
            } else {
                this.currentMonth = 1
                this.currentYear++
            }
            this.getListRentalBoatAcordingMonth()
        },
        getListRentalBoatAcordingMonth () {
            this.dibbleJs.showLoader();
            const params = {
                request: DibbleApi.api.getMonthAvailabilityCalendar,
                month: this.currentMonth,
                year: this.currentYear
            }
            DibbleJS.callApiRequest(params, response => {
                if (DibbleApi.isResponseSuccess(response)) {
                    for (let i = response.cells.length - 1; i >= 0; i --) {
                        if (!response.cells[i].is_visible) {
                            response.cells[i].displayNone = true
                        } else {
                            break
                        }
                    }
                    this.listDaysInMonth = response.cells
                } else {
                    DibbleJS.toastErrorMessage(response.message);
                }
                this.dibbleJs.hideLoader()
            });
        }
    },
    mounted () {
        const d = new Date()
        this.currentMonth = d.getMonth() + 1
        this.currentYear = d.getFullYear()
        this.getListRentalBoatAcordingMonth()
        window.onresize = () => {
            this.windowWidth = window.innerWidth
        }
    },
    watch: {
        currentMonth(value) {
            if (value) {
                this.currentMonthText = this.listMonth.find(el => el.key === value).text
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .main-calendar {
        width:100vw;
        height: 100vh;
        background: url('../../assets/images/bg.jpg') no-repeat center top;
        background-size: cover;
        padding: 20px;
        overflow:auto
    }
    .cards {
        display: flex;
        flex-wrap: wrap;
        margin-left: calc(-1 * var(--spacing));
        --spacing: 30px;
        --columns: 7;
    }
    .list-day {
        display: flex;
        flex-wrap: wrap;
        margin-left: calc(-1 * var(--spacing));
        --spacing: 30px;
        --columns: 7;
        margin-bottom: 10px;
        height: 35px;
    }
    .day-weeks {
        display: flex;
        flex-direction: row;
        justify-content: center;
        width: calc(calc(100% / var(--columns)) - var(--spacing));
        text-align: center;
        background: #fff;
        border-top: 2px solid #405669;
        border-bottom: 2px solid #405669;
        font-size: 20px;
        color: #163856;
        font-family: 'Trocchi';
        font-weight: bold;
        cursor: pointer;
        -moz-user-select: none;
        -khtml-user-select: none;
        -webkit-user-select: none;
    }
    .scape-day {
        width: var(--spacing);
        background: #fff;
        border-top: 2px solid #405669;
        border-bottom: 2px solid #405669;
        &:nth-child(1) {
            background: initial;
            border: none;
        }
        -moz-user-select: none;
        -khtml-user-select: none;
        -webkit-user-select: none;
    }
    .card {
        border-radius: 20px;
        overflow: hidden;
        background-color: white;
        box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
        margin-left: var(--spacing);
        display: flex;
        flex-direction: column;
        width: calc(calc(100% / var(--columns)) - var(--spacing));
        height: 120px;
        margin-bottom: 10px;
        cursor: pointer;
        -moz-user-select: none;
        -khtml-user-select: none;
        -webkit-user-select: none;
        border: 2px solid #405669;
    }
    .add-custom-left {
        border-left: 2px solid #405669;
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
    }
    .add-custom-right {
        border-right: 2px solid #405669;
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
    }
    .card-top {
        height: 70px;
        display: flex;
        flex-direction: column;
        flex: 1;
        font-size: 50px;
        justify-content: center;
        align-items: center;
        color: #163856;
        font-family: 'Trocchi';
        font-weight: bold;
    }
    .card-bottom {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: auto;
        /* cố định chiều cao ở đó */
        flex-shrink: 0;
        height: 50px;
        color: #163856;
        font-weight: bold;
        font-size: 20px;
    }
    .logo {
        -moz-user-select: none;
        -khtml-user-select: none;
        -webkit-user-select: none;
    }
    .header-calendar {
        margin-bottom: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .button-select {
        cursor: pointer;
        &:nth-child(1) {
            padding-right: 5px;
        }
        &:last-child {
            padding-left: 5px;
        }
    }
    .calendar-select {
        -moz-user-select: none;
        -khtml-user-select: none;
        -webkit-user-select: none;
        display: flex;
        align-items: center;
    }
    .rental-ability {
        display: flex;
        align-items: center;
        width: 55%;
        background: #fff;
        border: 2px solid #405669;
        height: 60px;
        justify-content: space-around;
        border-radius: 10px;
    }
    .text-select {
        color: #163856;
        font-family: 'Trocchi';
        font-weight: bold;
        font-size: 30px;
    }
    .fixed-width {
        width: 220px;
        text-align: center;
    }
    .none-visible {
        visibility: hidden;
    }
    // responsive for mobile 
    @media only screen and (max-width: 600px) {
        .header-calendar {
            flex-direction: column;
            .logo {
                display: flex;
                justify-content: center;
                img {
                    width: 90%;
                }
            }
            .rental-ability {
                width: 100%;
                margin-top: 20px;
                height: 40px;
                .text-select {
                    font-size: 16px;
                }
                .button-select {
                    width: 30px;
                }
                .fixed-width {
                    width: 65%;
                }
            }
        }
        .cards {
            --spacing: 5px;
            .card {
                height: 90px;
            }
            .card-top {
                font-size: 30px;
                height: 60px;
            }
            .card-bottom {
                height: 30px;
            }
        }
        .list-day {
            --spacing: 5px;
            .day-weeks {
                span {
                    display: none;
                }
            }
        }
    }
</style>